import { FiZap } from "react-icons/fi"
import RenderSteps from "./RenderSteps"

const TIPS = [
  "Set the course price or make it free.",
  "Thumbnail should be 1024×576 (16:9 ratio).",
  "Add sections to organise your course content.",
  "Each section needs at least one lecture.",
  "You can save as draft and publish later.",
  "Use the rich text editor for detailed lecture descriptions.",
]

export default function AddCourse() {
  return (
    <div className="flex items-start gap-6 pb-10">
      {/* ── Main Form ──────────────────────────────────────────── */}
      <div className="flex min-w-0 flex-1 flex-col">
        <h1 className="mb-8 text-2xl font-bold text-richblack-5">
          Create New Course
        </h1>
        <RenderSteps />
      </div>

      {/* ── Tips sidebar ───────────────────────────────────────── */}
      <aside className="sticky top-6 hidden w-72 flex-shrink-0 xl:block">
        <div className="rounded-2xl border border-richblack-700 bg-richblack-800 p-5">
          <div className="mb-4 flex items-center gap-2">
            <FiZap size={15} className="text-yellow-50" />
            <p className="text-sm font-semibold text-richblack-5">Upload Tips</p>
          </div>
          <ul className="space-y-2.5">
            {TIPS.map((tip, i) => (
              <li key={i} className="flex items-start gap-2 text-xs text-richblack-300">
                <span className="mt-0.5 flex-shrink-0 text-yellow-50">•</span>
                {tip}
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  )
}
